import { isLowMode } from "./lowmode";

export const generateAvatarFormat = (avatarFormat?: 'qvga' | 'vga' | 'hd' | 'full') => {
    if (avatarFormat) {
        return avatarFormat;
    }
    return isLowMode() ? 'qvga' : undefined;
}import { isLowMode } from "./lowmode";

export const generateAvatarFormat = (avatarFormat?: 'qvga' | 'vga' | 'hd' | 'full') => {
    if (avatarFormat) {
        return avatarFormat;
    }
    return isLowMode() ? 'qvga' : undefined;
}